import { useModalCommentSectionQuery } from 'generated/graphql';

import React from 'react';

export interface IData {
  id: string;
  personName: string;
  createdAt: string;
  description: string;
}

export function useQuery(taskId: string) {
  const tuple = useModalCommentSectionQuery({
    variables: {
      id: taskId
    },
    skip: taskId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.task?.comments.map((node) => ({
        id: node.id ?? '',
        personName: node.person.fullName ?? '',
        createdAt: node.createdAt.toFormat('DDDD'),
        description: node.description ?? ''
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
